import React from 'react';

import { WebToAppFlowModal } from '@auspost/mpc-uikit-wtaf-modal';
import { WebToAppFlowModalMetaData } from '@auspost/mpc-uikit-wtaf-modal/dist/lib/components/WebToAppFlowModal/webToAppFlowModal.model';
import { Button } from '@auspost/postmaster-react/raw';

import { config } from '../../../../config/env-config';
import { extLnkLiiaspFAQ } from '../../../../config/track-config';
import { trackInteraction } from '../../../../store/analytics/analytics.thunks';
import { useAppDispatch } from '../../../../store/store';

interface LiiaspWebToAppModalProps {
  isOpen: boolean;
  articleId: string;
  onClose: () => void;
}

const LiiaspWebToAppModal: React.FC<LiiaspWebToAppModalProps> = ({ isOpen, articleId, onClose }) => {
  const dispatch = useAppDispatch();
  const externalLinkUrl = config.env.branchIoUrl + '/' + config.branchConfigs.liiaspQuickLink;
  const schemeUri = `auspost://trackdetails/${articleId}/safedrop`;
  const fallbackUrl = `${window.location.href}?branch_fallback=true`;
  const branchDeepLink = `${externalLinkUrl}?$deeplink_path=${schemeUri}&$fallback_url=${fallbackUrl}`;

  const onDownloadAppClick = () => {
    dispatch(trackInteraction('liiasp modal - continue in app open branch link'));
    window.open(branchDeepLink);
  };

  const onLearnMoreClick = () => {
    dispatch(trackInteraction('liiasp modal - open learn more'));
    window.open(extLnkLiiaspFAQ, '_blank');
  };

  const onDismissModal = () => {
    dispatch(trackInteraction('liisap modal - close web to app modal'));
    onClose();
  };

  const mobileFooter = (
    <>
      <Button onClick={onDownloadAppClick} size='medium' variant='primary' data-testid='download-app-button'>
        Continue in the app
      </Button>
      <Button onClick={onLearnMoreClick} size='medium' variant='tertiary'>
        Learn More
      </Button>
    </>
  );

  const metaData: WebToAppFlowModalMetaData = {
    $deeplink_path: schemeUri,
    $fallback_url: fallbackUrl,
  };
  return (
    <WebToAppFlowModal
      isOpen={isOpen}
      showMobileCloseButton
      externalLinkUrl={externalLinkUrl}
      metaData={metaData}
      learnMoreLink={extLnkLiiaspFAQ}
      footer={mobileFooter}
      onClose={onDismissModal}
    />
  );
};

export default LiiaspWebToAppModal;
